import { render, staticRenderFns } from "./OnboardingWizard.vue?vue&type=template&id=a6c054d4&lang=html&"
import script from "./OnboardingWizard.vue?vue&type=script&lang=js&"
export * from "./OnboardingWizard.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingWizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports